import pick from "lodash/pick"

const fields = {
  name: {
    label: "Nome"
  },
  address: {
    label: "Indirizzo",
    widget: "textarea"
  },
  zip_code: {
    label: "CAP"
  },
  town: {
    label: "Comune"
  },
  province: {
    label: "Provincia"
  },
  vat_id: {
    label: "P. IVA"
  },
  ssn_id: {
    label: "Codice fiscale"
  },
  email: {
    label: "Email"
  },
  pec: {
    label: "Email"
  },
  phone: {
    label: "Tel"
  },
  payment_method: {
    label: "Metodo di pagamento",
    widget: "radio",
    choices: {
      BONIFICO: { name: "bonifico bancario" },
      BONIFICO_PRE: { name: "bonifico anticipato" },
      BONIFICO_30: { name: "bonifico bancario 30gg fm + 10gg" },
      BONIFICO_30_DF: { name: "bonifico bancario 30gg df + 10gg" },
      CARTE: { name: "carta di credito" },
      NOLEGGIO_OP: { name: "noleggio operativo" }
    }
  },
  notes: {
    label: "Note",
    widget: "textarea"
  }
}

const showFields = pick(
  fields,
  "address",
  "referent",
  "phone",
  "email",
  "vat_id"
)

export { fields, showFields }
